import React from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../../common/head-container';

const AttemptsExhausted = ({
  setScreenNumber,
  telegramLink,
  checkPhoneNumber
}) => {
  return (
    <div className={styles.container}>
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>Спроби вичерпані:(</p>
        <p className={styles.description}>
          Спробуй перевірити вказаний номер телефону та зареєструватися знову!
        </p>
        <button onClick={checkPhoneNumber} className={styles.nextButton}>
          <img
            className={styles.buttonGlowTop}
            src="/images/ua-lm-1test-auth/button-glow-top.svg"
            alt=""
          />
          <img
            className={styles.buttonGlowBottom}
            src="/images/ua-lm-1test-auth/button-glow-bottom.svg"
            alt=""
          />
          <span>Перевірити номер</span>
        </button>
      </div>
    </div>
  );
};

export default AttemptsExhausted;
